import { useIsomorphicLayoutEffect } from 'framer-motion';
import { useState } from 'react';

export const useComponentBoundingBox = <
  T extends HTMLElement = HTMLDivElement,
>(): [(node: Nullable<T>) => void, Possible<DOMRect>] => {
  const [ref, setRef] = useState<Nullable<T>>(null);
  const [boundingBox, setBoundingBox] = useState<DOMRect>();

  useIsomorphicLayoutEffect(() => {
    if (!ref) return;

    const handleResize = () => {
      setBoundingBox(ref.getBoundingClientRect());
    };

    handleResize();

    if (typeof ResizeObserver === 'function') {
      const resizeObserver = new ResizeObserver(() => handleResize());
      resizeObserver.observe(ref);

      return () => {
        resizeObserver.disconnect();
      };
    } else {
      window.addEventListener('resize', handleResize);

      return function () {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [ref]);
  return [setRef, boundingBox];
};
